// On web we don't need to do anything
export function* tokenSaga() {}
